const isMobileOrTablet = {
  install(Vue) {
    Vue.prototype.$isMobileOrTablet = function () {
      return window.matchMedia("(max-width: 1024px)").matches;
    };
  },
};

export default isMobileOrTablet;
